module.exports = __webpack_public_path__ + "img/tattoo_2.947bbab8.png";